/* eslint-disable no-console */
import { parseISO } from 'date-fns';
import { format } from 'date-fns/esm';
import { TableRowItemData } from '../../../components/Table';
import { CLOSE_ICON } from '../../../assets/icons';
import { useState } from 'react';
import { additionalDetail } from '../../../api/additional-details';

export default function TableRowItem(data: any) {
  const [deleting, setDeleting] = useState(false);
  const [deleted, setDeleted] = useState<boolean>(data?.data?.deleted === true || data?.data?.found === false);
  return (
    <>
      <TableRowItemData text={format(parseISO(data?.data.updatedAt), 'dd/MM/yyyy')} />
      <TableRowItemData text={data?.data.childName} />
      <TableRowItemData text={data?.data.parentName} />
      <TableRowItemData text={data?.data.parentEmail} />
      <TableRowItemData text={data?.data.number} />
      <TableRowItemData text={data?.data.device} />
      {/* <TableRowItemData text={data?.data.subject} /> */}
      <TableRowItemData text={data?.data.class} />
      <TableRowItemData
        component={(() => {
          const requiredOk = Boolean(
            data?.data?.childName &&
              data?.data?.parentName &&
              data?.data?.parentEmail &&
              data?.data?.number &&
              data?.data?.device &&
              data?.data?.class
          );
          if (deleted) {
            return (
              <span className="flex items-center gap-1 px-2 py-1 rounded-md text-xs font-semibold bg-red-100 text-red-700">
                <img src={CLOSE_ICON} alt="deleted" className="w-3 h-3" />
                Deleted
              </span>
            );
          }
          const variant = requiredOk
            ? 'bg-neutral-200 text-gray-800 hover:bg-neutral-300'
            : 'bg-red-600 text-white hover:bg-red-700';
          return (
            <button
              className={`flex items-center gap-1 px-2 py-1 rounded-md text-xs font-semibold disabled:opacity-60 ${variant}`}
              disabled={deleting}
              onClick={async (e) => {
                e.stopPropagation();
                try {
                  setDeleting(true);
                  await additionalDetail.deleteBooktrail(data?.data?._id).then((res) => console.log(res));
                  setDeleted(true);
                } catch (err) {
                  setDeleting(false);
                } finally {
                  setDeleting(false);
                }
              }}
            >
              <img src={CLOSE_ICON} alt="delete" className="w-3 h-3" />
              {deleting ? 'Deleting...' : 'Delete'}
            </button>
          );
        })()}
      />
    </>
  );
}
